"use client";

import dynamic from "next/dynamic";
import { cn } from "@/lib/utils/cn";

const MapLibreExploreMap = dynamic(
  () =>
    import("@/app/(app)/explore/components/MapLibreExploreMap").then((mod) => ({
      default: mod.MapLibreExploreMap,
    })),
  {
    ssr: false,
    loading: () => <div className="size-full rounded-full bg-muted/40" aria-hidden />,
  },
);

export interface GlobeProps {
  size?: number;
  className?: string;
}

const GLOBE_CAMERA: { center: [number, number]; zoom: number } = {
  center: [20, 0],
  zoom: 0.9,
};

export function Globe({ size = 280, className }: GlobeProps) {
  return (
    <div
      className={cn("relative shrink-0 overflow-hidden rounded-full border border-border", className)}
      style={{ width: size, height: size }}
    >
      <MapLibreExploreMap
        places={[]}
        countries={[]}
        mapTheme="tropicalCoast"
        center={GLOBE_CAMERA.center}
        zoom={GLOBE_CAMERA.zoom}
        height="100%"
        className="h-full min-h-0 w-full rounded-none border-0"
        variant="desktop"
        projectionMode="globe"
        spinGlobe
        spinSpeed="normal"
        interactive={false}
        showPins={false}
        clusterEnabled={false}
        layerMode="all"
      />
    </div>
  );
}
